module.exports = __webpack_public_path__ + "img/ellipsis-active.ae066c4b.svg";